import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const Header = () => {
  const [isOpenLogin, setIsOpenLogin] = useState(false);
  const [isOpenCategories, setIsOpenCategories] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [categories, setCategories] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [navbar, setNavbar] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const loginRef = useRef(null);
  const categoriesRef = useRef(null);
  const location = useLocation();
  const [infoCompany, setInfoCompany] = useState(null);
  const [hoveredMainMenu, setHoveredMainMenu] = useState(null);
  const [hoveredSubMenu, setHoveredSubMenu] = useState(null);
  const [hoveredNavItem, setHoveredNavItem] = useState(null);
  const [hoveredSubNavItem, setHoveredSubNavItem] = useState(null);

  const handleMainMenuEnter = (menuId) => {
    setHoveredMainMenu(menuId);
  };

  const handleMainMenuLeave = () => {
    setHoveredMainMenu(null);
  };

  const handleSubMenuEnter = (menuId) => {
    setHoveredSubMenu(menuId);
  };

  const handleSubMenuLeave = () => {
    setHoveredSubMenu(null);
  };

  const handleNavItemEnter = (itemId) => {
    setHoveredNavItem(itemId);
  };

  const handleNavItemLeave = () => {
    setHoveredNavItem(null);
  };

  const handleSubNavItemEnter = (itemId) => {
    setHoveredSubNavItem(itemId);
  };

  const handleSubNavItemLeave = () => {
    setHoveredSubNavItem(null);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (loginRef.current && !loginRef.current.contains(event.target))
        setIsOpenLogin(false);
      setIsOpenCategories(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const updateCartCount = () => {
      const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
      setCartCount(cartItems.length);
    };

    updateCartCount();

    const handleStorageChange = (e) => {
      if (e.key === "cart") {
        updateCartCount();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    const handleCartUpdate = () => updateCartCount();
    window.addEventListener("cartUpdated", handleCartUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    if (userId) {
      setIsLogin(true);
    }
    getData();
    getNavbarData();
    getPageSection();
  }, []);

  const getPageSection = () => {
    axios
      .get("/page-section/public/shows?sectionType=infoCompany")
      .then((res) => {
        setInfoCompany(res.data.data[0]);
      })
      .catch((err) => console.log(err));
  };

  const getContentByKey = (key) => {
    if (!infoCompany || !infoCompany.content) return "";
    const item = infoCompany.content.find((item) => item.key === key);
    return item ? item.value : "";
  };

  // const getUrlByKey = (key) => {
  //   if (!infoCompany || !infoCompany.content) return "#";
  //   const item = infoCompany.content.find((item) => item.key === key);
  //   return item && item.url ? item.url : "#";
  // };

  const getData = () => {
    axios
      .get("/category/public/shows-tree")
      .then((res) => {
        const categoryData = res.data.data;
        setCategories(categoryData);
      })
      .catch((err) => console.log(err));
  };

  const getNavbarData = () => {
    axios
      .get("/navigation/public/shows")
      .then((res) => {
        setNavbar(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    right: "0",
    minWidth: "120px",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    opacity: 0,
    visibility: "hidden",
    transform: "translateY(5px)",
    transition: "opacity 0.2s ease, transform 0.2s ease, visibility 0.2s",
    zIndex: 1,
  };

  const dropdownShowStyle = {
    ...dropdownStyle,
    opacity: 1,
    visibility: "visible",
    transform: "translateY(0)",
  };

  const dropdownItemStyle = {
    display: "block",
    width: "100%",
    padding: "8px 12px",
    fontSize: "14px",
    background: "none",
    border: "none",
    textAlign: "left",
    cursor: "pointer",
    outline: "none",
    color: "#000",
    textDecoration: "none",
  };

  const dropdownCategoriesStyle = {
    position: "absolute",
    top: "100%",
    left: 15,
    width: "calc(100% - 30px)",
    zIndex: 2,
    background: "#f8f9fa",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    padding: "10px 0",
    opacity: 0,
    visibility: "hidden",
    transform: "translateY(5px)",
    transition: "opacity 0.2s ease, transform 0.2s ease, visibility 0.2s",
  };

  const dropdownCategoriesShowStyle = {
    ...dropdownCategoriesStyle,
    opacity: 1,
    visibility: "visible",
    transform: "translateY(0)",
  };

  const dropdownSubmenuStyle = {
    position: "absolute",
    left: "100%",
    top: "0",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    minWidth: "150px",
    display: "none",
  };

  const dropdownSubmenuShowStyle = {
    ...dropdownSubmenuStyle,
    display: "block",
  };

  const dropdownSubmenuStyleDown = {
    position: "absolute",
    left: "0",
    top: "100%",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    minWidth: "150px",
    display: "none",
  };

  const dropdownSubmenuShowStyleDown = {
    ...dropdownSubmenuStyleDown,
    display: "block",
  };

  const navigate = useNavigate();

  const handleSearch = () => {
    setKeyword("");
    navigate(`/san-pham?s=` + keyword);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("fullName");
    localStorage.removeItem("avatar_url");
    localStorage.removeItem("email");
    localStorage.removeItem("numberPhone");

    navigate("/");
    window.location.reload();
  };

  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    setIsCollapsed(true);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* Header */}
      <div className="container-fluid">
        <div
          className={`row bg-secondary md:py-2 px-xl-5 ${
            isSticky ? "sticky-menu z-index-1021 " : ""
          } `}
        >
          <div className="col-lg-6 d-none d-lg-block">
            <div className="d-inline-flex align-items-center h-100">
              <Link
                className="mr-3 text-dark"
                to={`tel:${getContentByKey("number_phone")}`}
              >
                Hotline: {getContentByKey("number_phone")}
              </Link>
              <span className="mr-3 text-dark">
                Giờ làm việc: {getContentByKey("working_hours")}
              </span>
            </div>
          </div>
          <div className="col-lg-6 text-center text-lg-right max-md:hidden">
            <div className="d-inline-flex align-items-center w-full justify-between md:justify-end">
              <div className="btn-group me-2">
                <Link
                  to="/cart"
                  type="button"
                  className="btn btn-light font-weight-bold"
                >
                  <i className="fas fa-shopping-cart "></i>&nbsp; Giỏ hàng
                  {
                    <span
                      className="badge text-warning bg-danger rounded-circle"
                      style={{
                        top: "-15px",
                        right: "-15px",
                        fontSize: "0.75rem",
                      }}
                    >
                      {cartCount === 0 ? "" : cartCount}
                    </span>
                  }
                </Link>
              </div>

              <div className="btn-group" ref={loginRef}>
                <span
                  className="dropdown-toggle btn btn-light flex items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsOpenLogin(!isOpenLogin)}
                >
                  {isLogin ? (
                    <>
                      <span className="text-sm d-none d-md-block me-1">
                        Xin chào:{" "}
                      </span>
                      <strong>{localStorage.getItem("fullName")}</strong>
                    </>
                  ) : (
                    <>
                      <i className="fas fa-user"></i>&nbsp; Đăng nhập
                    </>
                  )}
                </span>

                <div
                  className="z-index-1021"
                  style={isOpenLogin ? dropdownShowStyle : dropdownStyle}
                >
                  {!userId && (
                    <Link
                      style={dropdownItemStyle}
                      onMouseEnter={(e) =>
                        (e.target.style.background = "#f0f0f0")
                      }
                      onMouseLeave={(e) => (e.target.style.background = "none")}
                      to={"/login"}
                    >
                      Đăng nhập
                    </Link>
                  )}
                  {userId && (
                    <>
                      {/* <Link style={dropdownItemStyle} to={"/addresses"}>
                        Địa chỉ đặt hàng
                      </Link> */}
                      <Link style={dropdownItemStyle} to={"/wishlist"}>
                        Sản phẩm yêu thích
                      </Link>
                      <button style={dropdownItemStyle} onClick={handleLogout}>
                        Đăng xuất
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row align-items-center bg-light pb-3 px-xl-5 d-none d-lg-flex">
          <div className="col-lg-4">
            <Link to="/" className="text-decoration-none">
              <img
                src="/logo192.png"
                alt="logo"
                style={{ width: "5rem", height: "5rem" }}
              />
            </Link>
          </div>

          <div className="col-lg-8 col-6 ">
            <div className="row">
              <div className="col-lg-3 col-6 text-warning text-lg font-weight-bold">
                <i className="fa-solid fa-truck-fast fa-lg text-warning text-4xl"></i>{" "}
                Freeship 7Km
              </div>

              <div className="col-lg-3 col-6 text-danger text-lg font-weight-bold">
                <i className="fa-solid fa-fire-flame-curved fa-lg text-4xl"></i>{" "}
                Giao hàng hỏa tốc
              </div>

              <div className="col-lg-3 col-6 text-success text-lg font-weight-bold">
                <i className="fa-solid fa-percent fa-lg text-4xl"></i> Chiết
                khấu tới 15%
              </div>

              <div className="col-lg-3 col-6 text-info text-lg font-weight-bold">
                <i className="fa-solid fa-headset fa-lg text-4xl"></i> Hỗ trợ
                24/7
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <div className={`container-fluid mb-30 bg-main`}>
        <div
          className={`row px-xl-5 bg-dark box-shadow-11 ${
            isSticky ? "sticky-menu md:mt-12 max-md:mt-0" : "mt-0"
          }`}
        >
          <div
            className="col-lg-3 d-none items-center d-lg-flex "
            ref={categoriesRef}
          >
            <button
              className="btn d-flex align-items-center justify-content-between bg-white w-100"
              data-toggle="collapse"
              style={{ height: "65px", padding: "0 30px" }}
              onClick={() => setIsOpenCategories(!isOpenCategories)}
              onMouseEnter={() => setIsOpenCategories(true)}
              onMouseLeave={() => setIsOpenCategories(false)}
            >
              <h5 className="text-dark m-0 font-weight-bold text-xl">
                <i className="fa fa-bars mr-2"></i>Danh mục
              </h5>
              <i className={`fa fa-angle-down text-dark transition `}></i>
            </button>
            <nav
              className="position-absolute navbar navbar-vertical navbar-light align-items-start p-0 bg-light"
              style={
                isOpenCategories
                  ? dropdownCategoriesShowStyle
                  : dropdownCategoriesStyle
              }
            >
              <div className="navbar-nav w-100">
                {categories?.map((category, index) => {
                  if (category.subCategories?.length > 0) {
                    return (
                      <div
                        className="nav-item dropdown dropright"
                        key={index}
                        onMouseEnter={() => {
                          handleMainMenuEnter(category.id);
                          setIsOpenCategories(true);
                        }}
                        onMouseLeave={() => {
                          handleMainMenuLeave();
                          setIsOpenCategories(false);
                        }}
                      >
                        <Link
                          className="nav-link dropdown-toggle"
                          to={`/san-pham?c=${category.id}`}
                        >
                          {category.name}
                          <i className="fa fa-angle-right float-right mt-1"></i>
                        </Link>
                        <div
                          className="dropdown-menu position-absolute rounded-0 border-0 m-0"
                          style={
                            hoveredMainMenu === category.id
                              ? dropdownSubmenuShowStyle
                              : dropdownSubmenuStyle
                          }
                        >
                          {category.subCategories.map((item, idx) => {
                            if (item.subCategories?.length > 0) {
                              return (
                                <div
                                  className="nav-item dropdown dropright"
                                  key={idx}
                                  onMouseEnter={() =>
                                    handleSubMenuEnter(item.id)
                                  }
                                  onMouseLeave={handleSubMenuLeave}
                                >
                                  <Link
                                    className="nav-link dropdown-toggle"
                                    to={`/san-pham?c=${item.id}`}
                                  >
                                    {item.name}
                                    <i className="fa fa-angle-right float-right mt-1"></i>
                                  </Link>
                                  <div
                                    className="dropdown-menu position-absolute rounded-0 border-0 m-0"
                                    style={
                                      hoveredSubMenu === item.id
                                        ? dropdownSubmenuShowStyle
                                        : dropdownSubmenuStyle
                                    }
                                  >
                                    {item.subCategories.map(
                                      (subItem, subIdx) => (
                                        <Link
                                          to={`/san-pham?c=${subItem.id}`}
                                          className="nav-link dropdown-item"
                                          key={subIdx}
                                        >
                                          {subItem.name}
                                        </Link>
                                      ),
                                    )}
                                  </div>
                                </div>
                              );
                            } else {
                              return (
                                <Link
                                  to={`/san-pham?c=${item.id}`}
                                  className="nav-link dropdown-item"
                                  key={idx}
                                >
                                  {item.name}
                                </Link>
                              );
                            }
                          })}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <Link
                        to={`/san-pham?c=${category.id}`}
                        className="nav-item nav-link"
                        key={index}
                        onMouseEnter={() => {
                          setIsOpenCategories(true);
                        }}
                        onMouseLeave={() => {
                          setIsOpenCategories(false);
                        }}
                      >
                        {category.name}
                      </Link>
                    );
                  }
                })}
              </div>
            </nav>
          </div>
          <div className="col-lg-9">
            <nav className="navbar navbar-expand-lg navbar-light p-0">
              <Link to={"/"} className="text-decoration-none d-block d-lg-none">
                <img
                  src="/logo192.png"
                  alt="logo"
                  style={{ width: "4rem", height: "4rem" }}
                />
              </Link>

              <button
                type="button"
                className="navbar-toggler bg-white "
                onClick={toggleNavbar}
                aria-expanded={!isCollapsed}
                aria-controls="navbarCollapse"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div
                className={`collapse navbar-collapse  ${
                  isCollapsed ? "" : "show"
                }`}
                id="navbarCollapse"
              >
                <div className="navbar-nav mr-auto py-3 py-sm-0">
                  {[...navbar]
                    ?.filter((item) => item.parentId === null)
                    .map((item, idx) => (
                      <div
                        key={idx}
                        className="nav-item"
                        onMouseEnter={() => handleNavItemEnter(item.id)}
                        onMouseLeave={handleNavItemLeave}
                      >
                        <Link
                          to={item.url}
                          className={`nav-link dropdown-toggle text-white position-relative py-3 text-xl  ${
                            location.pathname === `/${item.url}` ? "active" : ""
                          }`}
                        >
                          {item.title}
                          {item.children?.length > 0 && (
                            <i className="fa fa-angle-down ml-1"></i>
                          )}

                          {item.children?.length > 0 && (
                            <div
                              className="dropdown-menu position-absolute rounded-0 border-0 m-0"
                              style={
                                hoveredNavItem === item.id
                                  ? dropdownSubmenuShowStyleDown
                                  : dropdownSubmenuStyleDown
                              }
                            >
                              {item.children.map((child, childIdx) => (
                                <div
                                  key={childIdx}
                                  className="dropdown-item"
                                  onMouseEnter={() =>
                                    handleSubNavItemEnter(child.id)
                                  }
                                  onMouseLeave={handleSubNavItemLeave}
                                >
                                  <Link
                                    to={child.url}
                                    className="nav-link dropdown-toggle d-flex justify-content-between align-items-center position-relative"
                                  >
                                    {child.title}
                                    {child.children?.length > 0 && (
                                      <>
                                        <i className="fa fa-angle-right ml-2"></i>
                                      </>
                                    )}

                                    {child.children?.length > 0 && (
                                      <div
                                        className="dropdown-menu position-absolute rounded-0 border-0 m-0"
                                        style={
                                          hoveredSubNavItem === child.id
                                            ? dropdownSubmenuShowStyle
                                            : dropdownSubmenuStyle
                                        }
                                      >
                                        {child.children.map(
                                          (subChild, subChildIdx) => (
                                            <Link
                                              key={subChildIdx}
                                              to={subChild.url}
                                              className="nav-link dropdown-item"
                                            >
                                              {subChild.title}
                                            </Link>
                                          ),
                                        )}
                                      </div>
                                    )}
                                  </Link>
                                </div>
                              ))}
                            </div>
                          )}
                        </Link>
                      </div>
                    ))}
                </div>
              </div>

              <div
                className={`col-lg-4 col-12 text-left ${
                  isCollapsed ? "d-none" : "d-block"
                } d-md-block px-0`}
              >
                <form action={handleSearch}>
                  <div className="input-group max-lg:pb-8">
                    <input
                      type="text"
                      value={keyword}
                      className="form-control"
                      placeholder="Tìm kiếm sản phẩm"
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        className="input-group-text bg-secondary"
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </nav>
          </div>
        </div>
      </div>

      <style>{`
        .sticky-menu {
          position: fixed;
          top: 0;
          left: 15px;
          right: 15px;
          z-index: 1000;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        body {
          /* Add padding to prevent content jump when menu becomes fixed */
          padding-top: ${isSticky ? "65px" : "0"};
          transition: padding 0.3s ease;
        }

        .navbar-nav {
          flex-wrap: wrap !important;
        }
      `}</style>
    </>
  );
};
